import { render, staticRenderFns } from "./redeem_code.vue?vue&type=template&id=36dbed02&scoped=true&"
import script from "./redeem_code.vue?vue&type=script&lang=js&"
export * from "./redeem_code.vue?vue&type=script&lang=js&"
import style0 from "./redeem_code.vue?vue&type=style&index=0&id=36dbed02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dbed02",
  null
  
)

export default component.exports